import React, { useEffect, useState } from "react";
import "../styles/verify.css";
import { Redirect, useLocation } from "react-router-dom";

function Verified() {
  const [checkVerify, setCheckVerify] = useState();
  const search = useLocation().search;
  const result = new URLSearchParams(search).get("result");
  const [cd, setCd] = useState();

  useEffect(() => {
    setCd(5);
  }, []);

  const redirectCD = () => {
    if (cd > 1) {
      setCd(cd - 1);
    } else if (cd === 1) {
      window.location.replace("/");
    }
  };

  useEffect(() => {
    setCheckVerify(result);
    setTimeout(() => {
      redirectCD();
    }, 1000);
  }, [cd]);

  return (
    <div className="verified">
      <div className="verified__conainer">
        {checkVerify && checkVerify}
        <p>Anasayfaya yönlendiriliyorsunuz... {cd}sn</p>
        <div className="topLeftBorder">
          <div>
            <div className="borderTop"></div>
            <div className="borderLeft"></div>
          </div>
        </div>
        <div className="bottomRigtBorder">
          <div>
            <div className="borderRight"></div>
            <div className="borderBottom"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Verified;
